<template>
  <div class="homepage-offers">
    <h2
      class="homepage-offers__headline"
      v-html="vueHomepageOffersTexts.textStrings.headline"></h2>
    <Slider
      v-if="products.length > 0"
      :amount-of-slides="products.length"
      slider-initialized>
      <template v-for="(product, index) in products">
        <SingleProductComplement
          :key="`product-${product.matchcode}-${index}`"
          :limiting-active="limitingActive"
          :product-info="product"
          :shopping-allowed="shoppingAllowed"
          :t="vueHomepageOffersTexts.textStrings" />
      </template>
    </Slider>
    <span
      v-if="products.length === 0 && !loading"
      v-html="vueHomepageOffersTexts.textStrings.noOffersAvailable"></span>
    <div
      v-if="products.length === 0 && loading"
      class="cp-round cp-spinner"></div>
  </div>
</template>

<script>
  import CustomerHelper from '@/helpers/CustomerHelper';
  import EventListenerHelper from '../../helpers/EventListenerHelper';
  import SingleProductComplement from '../layout/SingleProductComplement';
  import Slider from '../layout/Slider';

  export default {
    components: { SingleProductComplement, Slider },
    data() {
      return {
        currency: false,
        limitingActive: false,
        loading: true,
        mountedDocumentEventListeners: [
          { callback: this.activateLimiting, name: `rin-limiting-active` },
          { callback: this.activateLimiting, name: `rin-limiting-still-active` },
          { callback: this.updateShoppingAllowed, name: `rin-limiting-shopping-allowed` },
          { callback: this.updateShoppingDisallowed, name: `rin-limiting-shopping-disallowed` },
        ],
        products: [],
        shoppingAllowed: false,
        vueHomepageOffersTexts: window.vueHomepageOffersTexts,
      };
    },
    async mounted() {
      CustomerHelper.setABTestForTestGroup(`2021-04-28`);
      EventListenerHelper.setUpEventListeners(this.mountedDocumentEventListeners);
      this.products = await this.$productService.getHomepageOfferProducts();
      this.loading = false;
    },
    beforeDestroy() {
      EventListenerHelper.teardownEventListeners(this.mountedDocumentEventListeners);
    },
    methods: {
      activateLimiting() {
        this.limitingActive = true;
      },
      updateShoppingAllowed() {
        this.shoppingAllowed = true;
      },
      updateShoppingDisallowed() {
        this.shoppingAllowed = false;
      },
    },
  };
</script>

<style lang="less" scoped>
  .homepage-offers {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin-bottom: 70px;
    width: 100%;

    &__headline {
      width: 100%;
    }
  }

  .rin-slider {
    height: 225px;
    padding-bottom: 115px;
    width: 100%;
  }
</style>
